import React from 'react';
import { Leaf, Phone } from 'lucide-react';

export default function PromoBar() {
  return (
    <div className="bg-[#1B4631] text-[#F6F2E8] text-xs sm:text-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-2.5 flex items-center justify-between gap-4">
        <div className="flex items-center gap-2">
          <Leaf className="w-4 h-4 text-[#E8C56B]" strokeWidth={2} />
          <span className="hidden sm:inline" data-testid="promo-banner-text">
            <span className="font-semibold text-[#E8C56B]">Planning for a crowd?</span> Get 10% off catering orders for 50+ people!
          </span>
          <span className="sm:hidden" data-testid="promo-banner-text-mobile">10% off orders for 50+ people!</span>
        </div>
        <div className="hidden md:flex items-center gap-6">
          <span>24-hour notice • $300 minimum • Free delivery</span>
          <a href="tel:7738570230" className="flex items-center gap-1.5 hover:text-[#E8C56B] transition-colors">
            <Phone className="w-3.5 h-3.5" />
            <span>773-857-0230</span>
          </a>
        </div>
      </div>
    </div>
  );
}
